import $ from 'jquery';
import pubsub from 'common/js/pubsub';

/**
 * 尝试打开app
 */
var u = navigator.userAgent;
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
var iosVersion = (isiOS && (u.match(/OS\s*(\d+)/))[1]) || 0;//IOS设备版本
var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
var androidVersion = (isAndroid && u.substr(u.indexOf('Android') + 8, 3)) || 0; //安卓设备版本
var isWeiXin = u.toLowerCase().match(/MicroMessenger/i) === 'micromessenger'; //微信浏览器打开
//var isWeibo = u.toLowerCase().match(/WeiBo/i) === 'weibo' ;//微博打开
var isQQBrowser = u.indexOf('QQBrowser') > -1 ;//QQ浏览器打开
var isMozilla = u.indexOf('Mozilla') > -1;//火狐中打开
var isPC = !( /Mobile/i.test(navigator.userAgent)) ;

var appLinks = {
    'pc': 'http://www.huya.com',
    'schema': 'yykiwi://',//协议
    'commonLink' : 'https://secstatic.yy.com/huya?ct=huyah5',//ios通用链接
    'qq': 'http://a.app.qq.com/o/simple.jsp?pkgname=com.duowan.kiwi&ckey=CK1374176186214' //应用宝链接
};

var oLink = getAppLink();

$('.J-openApp').prop('href', oLink.link);

//isMozilla && isiOS ios火狐浏览器中使用tap会有返回浏览器出现无法打开地址的提示故换成click
$('body').on(isMozilla ? 'click' : 'tap', '.J-openApp', function (e) {
    oLink = oLink || getAppLink();
    $(this).prop('href', oLink.link);

    if (!oLink.shouldBindEvent)return;

    e = e || window.event;
    e && e.preventDefault();
    //IOS>9,Android>5的版本，通过location.href打开
    tryOpen(e);
});

//获取链接
function getAppLink(){
    if (isPC) {//PC
        //需要打开app的直接跳首页
        return {
            link: appLinks.pc,
            shouldBindEvent : false
        };
    }
    // ios9及以上直接使用通用链接
    if (iosVersion >= 9) {
        return {
            link: appLinks.commonLink,
            shouldBindEvent : false
        };
    }

    //确定唤不起app的
    if (isWeiXin || (isQQBrowser && isiOS)) {
        return {
            link: appLinks.qq,
            shouldBindEvent : false
        };
    }
    return {
        link: appLinks.schema,
        shouldBindEvent : true
    };
}
//尝试打开
function tryOpen(e) {
    pubsub.publish('openApp','success');
    
    if( !e ){
        if( !oLink.shouldBindEvent ){
            window.location.href = oLink.link;
            return;
        }
    }

    //其他客户端或浏览器，尝试通过schema唤起，唤起失败则跳转对应地址
    var _loadUnistallTimer = null;//打开计时
    //页面是否被推到后台的判断
    var pageVisibility = pageVisibilityObj();
    //成功打开app的时候，会触发visibilitychange，应该停止跳转
    pageVisibility.visibilitychange(function() {
        clearTimeout(_loadUnistallTimer);
    });


    var ifr,
        faillink =  appLinks.qq,
        appschema = appLinks.schema;

    if( iosVersion >= 9 || androidVersion >= 5 ){

        if(isMozilla){
            ifr = document.createElement('iframe');
            ifr.src = appschema;
            ifr.style.display = 'none';
            document.body.appendChild(ifr);

        }else{
            window.location = appschema;
        }

        _loadUnistallTimer =  window.setTimeout(function () {
            window.location = faillink;
        }, 3000);

    }else{
        //其他用iframe
        ifr = document.createElement('iframe');
        ifr.src = appschema;
        ifr.style.display = 'none';
        document.body.appendChild(ifr);

        var loadDateTime = new Date();
        //通过定时判断手机内是否安装有app，如果手机内安装有app则启动app再返回浏览器页面的时间>1s
        window.setTimeout(function () {
            document.body.removeChild(ifr);
            var timeOutDateTime = new Date();
            var diffTime = timeOutDateTime-loadDateTime;
            if (diffTime < 1100) {
                //进入下载页
                window.location.href = faillink;
            }
        }, 1000);
    }
}
//唤起事件捕获
function pageVisibilityObj() {
    var prefixSupport, keyWithPrefix = function(prefix, key) {
        if (prefix !== "") {
            // 首字母大写
            return prefix + key.slice(0,1).toUpperCase() + key.slice(1);
        }
        return key;
    };
    var isPageVisibilitySupport = (function() {
        var support = false;
        if (typeof window.screenX === "number") {
            ["webkit", "moz", "ms", "o", ""].forEach(function(prefix) {
                if (support === false && document[keyWithPrefix(prefix, "hidden")] !== undefined) {
                    prefixSupport = prefix;
                    support = true;
                }
            });
        }
        return support;
    })();

    var isHidden = function() {
        if (isPageVisibilitySupport) {
            return document[keyWithPrefix(prefixSupport, "hidden")];
        }
        return undefined;
    };

    var visibilityState = function() {
        if (isPageVisibilitySupport) {
            return document[keyWithPrefix(prefixSupport, "visibilityState")];
        }
        return undefined;
    };

    return {
        hidden: isHidden(),
        visibilityState: visibilityState(),
        visibilitychange: function(fn, usecapture) {
            usecapture = undefined || false;
            if (isPageVisibilitySupport && typeof fn === "function") {
                return document.addEventListener(prefixSupport + "visibilitychange", function(evt) {
                    this.hidden = isHidden();
                    this.visibilityState = visibilityState();
                    fn.call(this, evt);
                }.bind(this), usecapture);
            }
            return undefined;
        }
    };
}

export default tryOpen;


// WEBPACK FOOTER //
// ./src/common/js/openApp.js